import Swal from "sweetalert2";
<template>
  <div class="card card-custom gutter-b">
    <div class="card-header">
      <div class="card-title">
        Danh sách Danh mục
      </div>
      <div class="card-title">
        <router-link class="font-weight-bold font-size-3 btn btn-success" :to="{name: 'category-create'}">Thêm mới</router-link>
      </div>
    </div>
    <div class="card-body" v-loading="loading">
      <div class="example mb-10">
        <div class="row">
          <div class="form-group col-md-3">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text line-height-0 py-0">
                  <span class="svg-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <rect x="0" y="0" width="24" height="24"></rect>
                        <path d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z"
                              fill="#000000" fill-rule="nonzero"
                              opacity="0.3"></path>
                        <path d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z"
                              fill="#000000"
                              fill-rule="nonzero"></path>
                      </g>
                    </svg>
                    <!--end::Svg Icon-->
                  </span>
                </span>
              </div>
              <input type="text" class="form-control" placeholder="Tên danh mục" v-model="formSearch.name" aria-describedby="basic-addon2" @keyup="handleFormSearch">
            </div>
          </div>
          <div class="form-group col-md-3">
            <div class="form-group">
              <el-select v-model="formSearch.department_id" filterable clearable class="w-100" placeholder="Chọn phòng ban" @change="handleFormSearch">
                <el-option
                        v-for="item in departments"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                >
                  <span style="float: left">{{ item.name }}</span>
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <el-select
                  ref="userSelect"
                  v-model="formSearch.handler"
                  filterable size="large"
                  remote class="w-100"
                  @change="handleFormSearch" clearable
                  placeholder="Tìm kiếm người xử lý"
                  :remote-method="remoteMethod"
                  :loading="loading">
                <el-option
                    v-for="item in handlerOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="example-preview table-responsive">
          <table class="table table-vertical-center">
            <thead>
              <tr>
                <th>STT</th>
                <th>Mã danh mục</th>
                <th>Tên danh mục</th>
                <th>Phòng ban</th>
                <th>Thời gian nhập giải pháp</th>
                <th>Trạng thái</th>
                <th>Người xử lý</th>
                <th style="min-width: 100px">Hành động</th>
              </tr>
            </thead>
            <tbody>
            <tr v-if="data.length > 0" v-for="(item, key) in data">
              <td>{{ key + 1 }}</td>
              <td>{{ item.id }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.department }}</td>
              <td>{{ item.time }}</td>
              <td>
                <category-change-status :ticket-category="item"></category-change-status>
              </td>
              <td>{{ item?.user_handle_name ?? '' }}</td>
              <td>
                <router-link :to="{ name: 'category-edit', params: {id : item.id} }" title="Sửa" class="btn btn-sm btn-icon mr-2 btn-outline-info">
                  <i class="fas fa-pen-nib"></i>
                </router-link>
                <button :disabled="item.check_delete !== 1" :title="item.check_delete == 1 ? 'Xóa' : 'Không thể xóa danh mục đã được gán ticket'" @click="deleteTicketCategory(item.id)" href="javascript:"
                   class="btn btn-sm btn-icon btn-outline-danger"><i class="fas fa-trash"></i></button>
              </td>
            </tr>
            <tr v-if="data.length === 0 && !loading">
              <td colspan="9" class="event-title no-data">Chưa có dữ liệu</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="edu-paginate mx-auto text-center">
      <paginate
              v-model="page"
              :page-count="last_page"
              :page-range="3"
              :margin-pages="1"
              :click-handler="clickCallback"
              :prev-text="'Trước'"
              :next-text="'Sau'"
              :container-class="'pagination b-pagination'"
              :pageLinkClass="'page-link'"
              :next-link-class="'next-link-item'"
              :prev-link-class="'prev-link-item'"
              :prev-class="'page-link'"
              :next-class="'page-link'"
              :page-class="'page-item'"
      >
      </paginate>
    </div>
  </div>
</template>

<script>
    import {SET_BREADCRUMB} from "../../../core/services/store/breadcrumbs.module";
    import 'vue2-datepicker/index.css';
    import '@/assets/sass/custom/custom_event.scss';
    import Swal from "sweetalert2";
    import {
        DELETE_CATEGORY,
        GET_CATEGORY,
        GET_DEPARTMENT
    } from "../../../core/services/store/ticket-category/category.module";
    import CategoryChangeStatus from "./Category-Change-Status";
    import {TICKET_CATEGORY} from "../../../core/option/ticketCategory";
    import {FIND_USER_BY_KEYWORD} from "../../../core/services/store/okrs/okr.module";

    export default {
        components: {
            CategoryChangeStatus,
        },
        name: "CategoryList",
        data() {
            return {
                formSearch: {
                    name: '',
                    type: '',
                    priority: '',
                    handler: null
                },
                departments: [],
                data: [],
                page: 1,
                last_page: 1,
                TICKET_CATEGORY,
                loading: false,
                queryUser: '',
                handlerOptions: []
            }
        },
        mounted() {
            this.getListDepartment()
            this.getListTicketCategory()
            this.$store.dispatch(SET_BREADCRUMB, [
                {title: "Quản lý Danh mục", route: 'category-list'},
                {title: "Danh sách Danh mục"}
            ]);
        },
        methods : {
            handleFormSearch() {
                this.page = 1
                this.getListTicketCategory()
            },
            getUsers() {
              const payload = {
                keyword: this.queryUser,
              }
              this.$store.dispatch(FIND_USER_BY_KEYWORD, payload).then(res => {
                if (!res.error) {
                  this.handlerOptions = res.data.map(item => {
                    return {
                      id: item.id,
                      name: `${item.id + 100000} - ${item.name} - ${item.department_name}`,
                    }
                  }) ?? []
                }
              })
            },
            remoteMethod(query) {
              if (query !== '') {
                this.queryUser = query
                this.loading = true;
                setTimeout(() => {
                  this.loading = false;
                  this.getUsers()
                }, 400);
              } else {
                this.teacherOptions = [];
              }
            },
            deleteTicketCategory(id) {
                Swal.fire({
                    title: "Bạn chắc chắn muốn xóa?",
                    showDenyButton: true,
                    showCancelButton: true,
                    confirmButtonText: "Đồng ý",
                    cancelButtonText: "Không",
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.$store.dispatch(DELETE_CATEGORY, id).then((res) => {
                            if (res.error) {
                                this.$bvToast.toast(res.message, {
                                    title: 'Xóa',
                                    variant: 'danger',
                                    solid: true
                                });
                            } else {
                                this.$bvToast.toast(res.message, {
                                    title: 'Xóa',
                                    variant: 'success',
                                    solid: true
                                });
                                this.getListTicketCategory();
                            }
                        }).catch((res) => {
                            this.$bvToast.toast(res.data.message, {
                                title: 'Xóa',
                                variant: 'danger',
                                solid: true
                            });
                        });
                    }
                });
            },
            getListTicketCategory() {
              this.loading = true;
              const payload = {
                page: this.page,
                name: this.formSearch.name,
                department_id: this.formSearch.department_id,
                priority: this.formSearch.priority,
                user_handle_id: this.formSearch.handler
              }
                this.$store.dispatch(GET_CATEGORY, payload).then((res) => {
                    this.data = res.data
                    this.last_page = res.pagination.last_page
                }).catch((e) => {
                    console.log(e)
                }).finally(() => this.loading = false);
            },
            getListDepartment() {
                this.$store.dispatch(GET_DEPARTMENT).then((res) => {
                    if (!res.error) {
                        this.departments = res.data
                    }
                }).catch((e) => {
                    console.log(e, 'error')
                });
            },
            clickCallback(obj) {
                this.page = obj
                this.getListTicketCategory()
            },

        }
    }
</script>

<style>
  .checkbox-slide, .checkbox-switch {
    border-radius: 20px !important;
  }
</style>
